<template>
    <div
        class="buttons"
        :class="[
            !isMobile? 'btnBox-horiz' : 'btnBox-vertical',
            {
                'btnBox-centered': isButtonCentered
            },
            buttonGroupClass
        ]"
    >
        <reo-common-button
            v-if="labelOfCancel"
            :customWidth="customWidth"
            :color-type="!switchButton?'light':'dark'"
            :label="labelOfCancel || $t( 'dialog.no' )"
            @click="$emit( 'cancel' )"
        ></reo-common-button>
        <reo-common-button
            v-if="labelOfMiddle"
            :color-type="switchButton?'light':'dark'"
            :label="labelOfMiddle || $t( 'dialog.yes' )"
            @click="$emit( 'middle' )"
        ></reo-common-button>
        <reo-common-button
            v-if="labelOfConfirm"
            :color-type="switchButton?'light':'dark'"
            :label="labelOfConfirm || $t( 'dialog.yes' )"
            @click="$emit( 'confirm' )"
            :customWidth="customWidth"
            :disabled="confirmDisabled || disableConfirm"
        ></reo-common-button>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoCommonButton from '@/components/ReoCommonButton.vue';

export default Vue.extend({
    components: {
        ReoCommonButton
    },
    props: {
        customWidth: [Number, String],
        switchButton: Boolean,
        labelOfCancel: String,
        labelOfMiddle: String,
        labelOfConfirm: String,
        confirmDisabled: Boolean,
        disableConfirm: Boolean,
        isMobile: Boolean,
        isButtonCentered: Boolean,
        buttonGroupClass: {
            type: String,
            default: ''
        }
    }
});
</script>
